import React, { Component } from "react";

class FeelingProud extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        id=""
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        width="0.0"
        height="0.0"
        viewBox="0 0 711.1879 669.68268"
      >
        <title></title>
        /> />
        <g id="" data-name="Group 13">
          />
        </g>
      </svg>
    );
  }
}

export default FeelingProud;
